/** biome-ignore-all lint/a11y/noStaticElementInteractions: TODO: @VadymMatok fix this */
/** biome-ignore-all lint/a11y/noNoninteractiveTabindex: TODO: @VadymMatok fix this */
/** biome-ignore-all lint/a11y/useKeyWithClickEvents: TODO: @VadymMatok fix this */
import clsx from 'clsx';
import {useSelector} from 'react-redux';

import {selectIsEmbedded} from '@/state/selectors/app';
import type {GuideCardProps} from '@/types/content';
import {TIPS_CARD_SIZES} from '@/types/content';

import BigCardContent from './BigCardContent';
import SmallCardContent from './SmallCardContent';

const TipsCard = ({
    title,
    imageMedia,
    size = TIPS_CARD_SIZES.SMALL,
    borderless = false,
    className,
    onClick,
}: GuideCardProps) => {
    const isEmbedded = useSelector(selectIsEmbedded);
    const isBigBorderless = size === TIPS_CARD_SIZES.BIG && borderless;
    const isBig = size === TIPS_CARD_SIZES.BIG;

    return (
        <div
            onClick={onClick}
            tabIndex={0}
            className={clsx(
                'flex cursor-pointer flex-col overflow-hidden rounded-2xl text-left',
                isEmbedded ? 'bg-tips-card-surface-secondary' : 'bg-tips-card-surface',
                !isBig && 'px-4 pt-4 pb-4',
                isEmbedded && !isBig && 'min-h-36',
                className
            )}
        >
            {isBig ? (
                <BigCardContent
                    title={title}
                    imageMedia={imageMedia}
                    isBigBorderless={isBigBorderless}
                />
            ) : (
                <SmallCardContent
                    title={title}
                    imageMedia={imageMedia}
                    borderless={borderless}
                />
            )}
        </div>
    );
};

export default TipsCard;
